<ul class="skipLinks" tabindex="0">
  <li class="skipLinks__item">
    <a class="skipLinks__item__link" [href]="skipLinkPath + links[0]" i18n="@@SKIP_LINKS.MAIN_CONTENT"
      >Go to the Main Content</a
    >
  </li>
  <li class="skipLinks__item">
    <a class="skipLinks__item__link" [href]="skipLinkPath + links[1]" i18n="@@SKIP_LINKS.MAIN_NAVIGATION"
      >Go to the Main Navigation</a
    >
  </li>
  <li class="skipLinks__item">
    <a class="skipLinks__item__link" [href]="skipLinkPath + links[3]" i18n="@@SKIP_LINKS.FOOTER">Go to the Footer</a>
  </li>
  <li *ngIf="!isLogged" class="skipLinks__item">
    <a class="skipLinks__item__link" [href]="skipLinkPath + links[5]">
      <span i18n="@@SKIP_LINKS.LOGIN_REGISTER">Log in or Sign up</span>
    </a>
  </li>
</ul>
